export const LINEAR_INTAKE_SETUP_COPY = {
  pageTitle: "How should Linear issues become tasks?",
  wizardStepConnect: "Connect Linear",
  wizardStepConnectHelper:
    "Connect Linear so SuperPlane can read issues and receive new issue events. A workspace admin must authorize the connection.",
  wizardStepConnectExisting: "Choose the Linear workspace that SuperPlane will monitor.",
  wizardStepProject: "Which Linear projects should create tasks?",
  wizardStepProjectHelper:
    "Select one or more projects. SuperPlane creates a task when an issue is added to a selected project.",
  importExistingHelper: "SuperPlane adds the 10 newest open issues from these projects.",
  importExistingHelperOff: "SuperPlane does not import existing issues.",
  wizardConnect: "Connect Linear",
  wizardOwnApp: "Use your own Linear app",
  wizardConnecting: "Connecting...",
  wizardConnectError: "SuperPlane could not open Linear authorization.",
  wizardContinue: "Continue",
  wizardFinish: "Finish",
  wizardFinishing: "Finishing...",
  wizardProjectsLoading: "Loading Linear projects...",
  wizardProjectsError: "SuperPlane could not load Linear projects.",
  wizardProjectsEmpty: "This connection has no available projects.",
  wizardNoMatchingProjects: "No matching projects.",
  wizardSearchProjects: "Search projects",
  wizardRetry: "Try again",
  wizardCreateError: "SuperPlane could not create the Linear intake.",
  wizardConnectionsLoading: "Loading Linear connections...",
  projectsRequired: "Select at least one Linear project.",
  projectsLabel: "Projects",
  labelsLabel: "Labels",
  labelsHelper: "Leave this empty to include every label.",
  labelInput: "Issue label",
  labelPlaceholder: "Type a label name",
  labelNew: "Add label",
  labelAdd: "Add",
  labelCancel: "Cancel",
} as const;
